import SettingsFormModel from './model/form.model.js';
import { success } from '@shared/ui/utils/toastr';

class SettingsController {
  constructor(SecurityApiService) {
    'ngInject';

    this.SecurityApiService = SecurityApiService;
  }

  $onInit() {
    this.form = new SettingsFormModel();
  }

  submit() {
    this.SecurityApiService.saveCredentials(this.form.toPayload())
    .then(() => {
      $('#settingsModal').modal('hide');
      success('Credentials has been successfully updated!');
      this.form.reset();
    })
    .catch((errors) => {
      this.form.setFormErrors(errors);
    })
    ;
  }
}

export default SettingsController;



// WEBPACK FOOTER //
// ./client/app/shared/system-components/settings/settings.modal.controller.js